import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { googleLoginWithCode } from '../../Redux/ActionCreators/authAction';
import { syncGoogleCalendar } from '../../Redux/ActionCreators/userAction';

function GoogleCallback() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const errorParam = params.get('error');
        const source = localStorage.getItem('googleAuthSource') || 'login';

        if (errorParam) {
            localStorage.removeItem('googleAuthSource');
            if (source === 'calendarSync') {
                navigate('/my-profile', { state: { calendarError: 'Google Calendar sync was cancelled.' } });
            } else {
                navigate('/' + source, { state: { googleError: 'Google sign-in was cancelled.' } });
            }
            return;
        }

        if (!code) {
            localStorage.removeItem('googleAuthSource');
            if (source === 'calendarSync') {
                navigate('/my-profile', { state: { calendarError: 'Google Calendar sync failed. No code received.' } });
            } else {
                navigate('/login', { state: { googleError: 'Google sign-in failed. No code received.' } });
            }
            return;
        }

        if (source === 'calendarSync') {
            const userId = localStorage.getItem('userId');
            dispatch(syncGoogleCalendar(userId, code)).then((res) => {
                localStorage.removeItem('googleAuthSource');
                if (res?.status === 200) {
                    navigate('/my-profile', { state: { calendarSuccess: 'Google Calendar synced successfully!' } });
                } else {
                    navigate('/my-profile', { state: { calendarError: 'Failed to sync Google Calendar. Please try again.' } });
                }
            });
            return;
        }

        dispatch(googleLoginWithCode(code)).then((res) => {
            localStorage.removeItem('googleAuthSource');
            if (res?.type === 'LOGIN_USER') {
                const details = JSON.parse(localStorage.getItem('profileDetails') || '{}');
                navigate(details?.roleId === '1' ? '/users' : '/jobs');
            } else {
                const msg = res?.errorMsg ||
                    (res?.status === 409
                        ? "Email already exists. Can't proceed with Google signup."
                        : 'Google sign-in failed. Please try again with email and password.');
                navigate('/' + source, { state: { googleError: msg } });
            }
        });
    }, []);

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
            <div className="spinner-border" role="status" style={{ color: '#F75891', width: 48, height: 48 }}>
                <span className="visually-hidden">Loading...</span>
            </div>
            <p style={{ color: '#fff', marginTop: 16, fontFamily: 'inter, sans-serif', fontSize: 14 }}>Connecting to Google ...</p>
        </div>
    );
}

export default GoogleCallback;
